import { useCallback, useContext } from 'react'
import { useDispatch } from 'react-redux'
import { CvsDrawer } from '@components'
import { fieldSetContext } from '@contexts'
import { EditField } from 'field-governance/edit-field'
import { showSnackbar } from 'functions'
import { t } from '@lingui/core/macro'

interface Props {
  isOpen: boolean
  onDrawerClose: () => void
  fieldset: any
}

export const AddFieldDrawer = ({ isOpen, onDrawerClose, fieldset }: Props) => {
  const { saveFieldSet } = useContext(fieldSetContext)
  const dispatch = useDispatch()

  const submitCallback = useCallback(
    form => {
      if (!fieldset) return

      const newFieldset = {
        ...fieldset,
        fields: [...(fieldset?.fields ?? []), form],
      }

      saveFieldSet(newFieldset)

      dispatch(
        showSnackbar({
          message: t`Field added to fieldset successfully.`,
          type: 'SUCCESS',
          duration: 5000,
        }),
      )
    },
    [fieldset],
  )

  if (!fieldset?.id) return null

  return (
    <CvsDrawer title={t`Add new field`} visible={isOpen} onClose={onDrawerClose}>
      <EditField
        close={onDrawerClose}
        submit={submitCallback}
        fieldSetId={String(fieldset?.id)}
        fieldId=""
        field={null}
      />
    </CvsDrawer>
  )
}
